import React from 'react';
import Gallery from '@browniebroke/gatsby-image-gallery';

type ProjectsGalleryProps = {
  projects: any[];
};
const ProjectsGallery: React.FC<ProjectsGalleryProps> = ({ projects }) => (
  <div className="container m-auto md:px-20 px-4 py-20 text-white text-center">
    {projects.map((project) => (
      <div key={project.projectName} className="mb-20">
        <div className="flex justify-center">
          <h1
            className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 w-3/4 pt-10 pb-20 lg:pt-20 lg:pb-40 px-4"
            style={{ backgroundColor: 'rgb(15, 22, 29, 0.4)' }}
          >
            {project.projectName}
          </h1>
        </div>
        <div className="-mt-16 lg:-mt-28 gallery">
          <Gallery
            colWidth={100}
            mdColWidth={33.333}
            imgClass="gallery-img transition-all cursor-pointer shadow-2xl flex-shrink"
            images={project.photos}
          />
        </div>
      </div>
    ))}
  </div>
);

export default ProjectsGallery;
